import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import GroupsIcon from "@mui/icons-material/Groups";
import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState } from "react";
import { AllDivisiActiveResponse } from "../../../models/Divisi";
import { AllLokasiResponse } from "../../../models/Job";
import useFetchAllLokasi from "../../../api/effects/queries/Job/useFetchAllLokasi";
import useFetchAllActiveDivisi from "../../../api/effects/queries/Divisi/useFetchAllActiveDivisi";
import { ResponsiveStyleValue, typography } from "@mui/system";


const PlaceHolderSearch = styled(Typography)(({ theme }) => ({
  textAlign: "center",
}));

const SearchGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "customWidth",
})<{ customWidth: any }>(({ theme, customWidth }) => ({
  backgroundColor: "white",
  border: "1px solid #00ACED",
  borderRadius: "90px",
  width: customWidth,
  [theme.breakpoints.down("md")]: {
    width: "90vw",
    borderRadius: "20px",
  },
  ...(typeof customWidth === "object" && {
    [theme.breakpoints.up("xs")]: { width: customWidth.xs },
    [theme.breakpoints.up("sm")]: { width: customWidth.sm },
    [theme.breakpoints.up("md")]: { width: customWidth.md },
    [theme.breakpoints.up("lg")]: { width: customWidth.lg },
    [theme.breakpoints.up("xl")]: { width: customWidth.xl }
  }),
}));

const InputWidth = styled(FormControl)(({ theme }) => ({
  width: "100%",
  height: "100%",
}));

const SelectFull = styled(Select)(({ theme }) => ({
  width: "100%",
  height: "100%",
  textAlign: "left",
}));

const SearchItemBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: "3%",
}));

const SearchButton = styled(Button)(({ theme }) => ({
  width: "90%",
  height: "70%",
  borderRadius: "90px",
  boxShadow: "none",
}));

type Props = {
  className?: string;
  width?: string | ResponsiveStyleValue<string>;
  search: string;
  handleEditSearch: (e: any) => void;
  divisi: string;
  divisiData: AllDivisiActiveResponse[];
  handleEditDivisi: (e: any) => void;
  lokasi: string;
  lokasiData: AllLokasiResponse[];
  handleEditLokasi: (e: any) => void;
  handleSearch: () => void;
};

export default function JobSearchBar({
  width = "60vw",
  search,
  divisi,
  divisiData,
  lokasi,
  lokasiData,
  handleEditSearch,
  handleEditDivisi,
  handleEditLokasi,
  handleSearch,
}: Props) {
  return (
    <SearchGrid container customWidth={width}>
      <Grid
        container
        justifyContent="center"
        direction="column"
        item
        sm={12}
        md={3}
      >
        <SearchItemBox>
          <SearchIcon
            sx={{
              padding: "3%",
            }}
          />
          <TextField
            placeholder="Tulis Pekerjaan"
            value={search}
            variant="standard"
            onChange={handleEditSearch}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </SearchItemBox>
      </Grid>
      <Grid
        container
        justifyContent="center"
        direction="column"
        item
        sm={12}
        md={3}
      >
        <SearchItemBox>
          <GroupsIcon
            sx={{
              padding: "3%",
            }}
          />
          <InputWidth variant="standard">
            <SelectFull
              placeholder="Pilih Divisi"
              displayEmpty
              renderValue={() =>
                divisi !== "" ? (
                  <Typography>
                    {(() => {
                      const text = divisiData.find((e) => e.value === divisi)?.text || "";

                      return text.length > 20 ? `${text.slice(0, 20)}...` : text;

                    })()}
                  </Typography>
                ) : (
                  <Typography color="rgba(0, 0, 0, 0.38)">
                    Pilih Divisi
                  </Typography>
                )
              }
              labelId="input-select-label-divisi"
              id="input-select-divisi"
              value={divisi}
              onChange={handleEditDivisi}
              disableUnderline
            >
              <MenuItem value={""}>All</MenuItem>
              {divisiData.map((value, key) => (
                <MenuItem value={value.value} key={key}>
                  {value.text}
                </MenuItem>
              ))}
            </SelectFull>
          </InputWidth>
        </SearchItemBox>
      </Grid>
      <Grid
        justifyContent="center"
        direction="column"
        container
        item
        sm={12}
        md={3}
      >
        <SearchItemBox>
          <LocationOnIcon
            sx={{
              padding: "3%",
            }}
          />
          <InputWidth variant="standard">
            <SelectFull
              placeholder="Pilih Lokasi"
              displayEmpty
              renderValue={() =>
                lokasi !== "" ? (
                  <Typography>
                    {lokasi.length > 23 ? `${lokasi.slice(0, 23)}...` : lokasi}
                  </Typography>
                ) : (
                  <Typography color="rgba(0, 0, 0, 0.38)">
                    Pilih Lokasi
                  </Typography>
                )
              }
              labelId="input-select-label-lokasi"
              id="input-select-lokasi"
              value={lokasi}
              onChange={handleEditLokasi}
              disableUnderline
            >
              <MenuItem value={""}>All</MenuItem>
              {lokasiData.map((value, key) => (
                <MenuItem value={value.value} key={key}>
                  {value.text}
                </MenuItem>
              ))}
            </SelectFull>
          </InputWidth>
        </SearchItemBox>
      </Grid>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="row"
        pb={{ xs: 1, sm: 1.5, md: 0 }}

        item
        sm={12}
        md={3}
      >
        <SearchButton variant="contained" onClick={handleSearch}
        >
          Cari Lowongan
        </SearchButton>
      </Grid>
    </SearchGrid>
  );
}
